"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Renders a basic list of active search entries
 *
 * @param {object} props
 * @param {object} props.classes Material UI classes
 * @param {string} [props.id] id of the list element
 * @param {string[]} [props.items] items to be displayed in the list
 * @param {function} [props.onDelete] function to be called when delete icon is clicked
 * @returns {JSX.Element}
 */
var SearchList = function SearchList(props) {
  var classes = props.classes,
    _props$id = props.id,
    id = _props$id === void 0 ? 'localFindCaseDropdown' : _props$id,
    _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    onDelete = props.onDelete;
  var deleteWrapper = function deleteWrapper(item) {
    if (onDelete) {
      onDelete(item);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    classes: {
      padding: classes.listPadding
    },
    id: id
  }, (items || []).reverse().map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Divider, {
      className: classes.divider
    }), /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      classes: {
        gutters: classes.listItemGutters
      },
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.searchResultDetailText
    }, /*#__PURE__*/_react.default.createElement("span", null, item)), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.deleteIcon,
      onClick: function onClick() {
        return deleteWrapper(item);
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/LocalFindCaseDeleteIcon.svg",
      alt: "close icon",
      className: classes.closeRoot
    }))));
  }));
};
var styles = function styles() {
  return {
    listPadding: {
      paddingTop: 0,
      paddingBottom: 4
    },
    deleteIcon: {
      cursor: 'pointer',
      marginTop: -4
    },
    closeRoot: {
      height: 10
    },
    listItemGutters: {
      padding: '0px 15px 0px 18px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    searchResultDetailText: {
      color: '#0D8662',
      lineHeight: '20px',
      fontFamily: 'Lato',
      fontSize: '11px',
      fontStyle: 'italic'
    },
    divider: {
      backgroundColor: '#B1B1B1',
      height: '1px',
      marginRight: 11,
      marginLeft: 12
    }
  };
};
var _default = (0, _core.withStyles)(styles)(SearchList);
exports.default = _default;